<router-outlet></router-outlet>

@if (showLoggingSetupButton) {
    <button mat-mini-fab class="!fixed bottom-4 right-4 tis-btn-filled-secondary z-50" (click)="openLoggingSettingsUiDialog()">
        <mat-icon>settings</mat-icon>
    </button>
}